if (!window.BFCartRecommendations) {
  window.BFCartRecommendations = true;

  if (!customElements.get('bf-cart-recommendations')) {
    customElements.define('bf-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        this.loadRecommendations();
      }

      async loadRecommendations() {
        const url = this.dataset.url;
        const list = this.querySelector('.bf-cart-recommendations__list');
        if (!url || !list) {
          this.remove();
          return;
        }

        try {
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to load recommendations');

          const markup = await response.text();
          const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
          const source = documentFragment.querySelector('.bf-cart-recommendations__source');
          if (!source) {
            this.remove();
            return;
          }

          const cartProductPaths = new Set(
            Array.from(document.querySelectorAll('.m-cart-drawer__body a[href*="/products/"]'))
              .map((link) => new URL(link.href, window.location.origin).pathname.replace(/\/$/, ''))
          );

          Array.from(source.querySelectorAll('.bf-cart-recommendations__item')).forEach((item) => {
            const itemPath = new URL(item.href, window.location.origin).pathname.replace(/\/$/, '');
            if (cartProductPaths.has(itemPath)) item.remove();
          });

          if (!source.children.length) {
            this.remove();
            return;
          }

          list.replaceChildren(...source.children);
          this.hidden = false;
        } catch (error) {
          this.remove();
        }
      }
    });
  }

  const markDrawerClosing = (drawer) => {
    if (!drawer) return;
    drawer.classList.add('bf-cart-drawer-closing');
    window.setTimeout(() => drawer.classList.remove('bf-cart-drawer-closing'), 420);
  };

  document.addEventListener('click', (event) => {
    const drawer = event.target.closest('.m-cart-drawer');
    const closeButton = event.target.closest('.m-cart-drawer__close');
    const cartTrigger = event.target.closest('.m-cart-icon-bubble');

    if (cartTrigger) {
      drawer?.classList.remove('bf-cart-drawer-closing');
      return;
    }

    if (closeButton || (drawer && !event.target.closest('.m-cart-drawer__inner'))) {
      markDrawerClosing(drawer);
      return;
    }

    const toggle = event.target.closest('.bf-cart-recommendations__toggle');
    if (!toggle) return;

    const recommendations = toggle.closest('.bf-cart-recommendations');
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!recommendations || !panel) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const isCollapsed = isExpanded;

    toggle.setAttribute('aria-expanded', String(!isCollapsed));
    toggle.setAttribute('aria-label', isCollapsed ? 'Expand recommendations' : 'Collapse recommendations');
    panel.setAttribute('aria-hidden', String(isCollapsed));
    panel.inert = isCollapsed;
    toggle.querySelector('span').textContent = isCollapsed ? '+' : '−';
    recommendations.classList.toggle('bf-cart-recommendations--collapsed', isCollapsed);
  });

  const updateScrollIndicator = (panel) => {
    const recommendations = panel.closest('.bf-cart-recommendations');
    if (!recommendations || panel.scrollWidth <= panel.clientWidth) return;

    const progress = panel.scrollLeft / (panel.scrollWidth - panel.clientWidth);
    recommendations.style.setProperty('--bf-recommendations-scroll-progress', `${progress}`);
    const scrollbar = recommendations.querySelector('.bf-cart-recommendations__scrollbar');
    const thumb = scrollbar && scrollbar.querySelector('span');
    if (scrollbar && thumb) {
      const maxOffset = Math.max(0, scrollbar.clientWidth - thumb.offsetWidth);
      thumb.style.transform = `translateX(${progress * maxOffset}px)`;
    }
    recommendations.classList.add('bf-cart-recommendations--scrolling');
    clearTimeout(panel._bfScrollTimer);
    panel._bfScrollTimer = setTimeout(() => {
      recommendations.classList.remove('bf-cart-recommendations--scrolling');
    }, 550);
  };

  document.addEventListener('scroll', (event) => {
    if (event.target instanceof HTMLElement && event.target.matches('.bf-cart-recommendations__list')) {
      updateScrollIndicator(event.target);
    }
  }, { passive: true, capture: true });
}
